import { del, get, post, put } from './client'

export interface CustomOAuthProvider {
  id: number
  name: string
  slug: string
  enabled: boolean
  client_id: string
  client_secret?: string
  authorization_endpoint: string
  token_endpoint: string
  user_info_endpoint: string
  scopes?: string
  user_id_field?: string
  username_field?: string
  display_name_field?: string
  email_field?: string
  icon?: string
  access_policy?: string
  [key: string]: unknown
}

export async function listCustomOAuthProvidersApi(): Promise<CustomOAuthProvider[]> {
  return get<CustomOAuthProvider[]>('/api/custom-oauth-provider/')
}

export async function createCustomOAuthProviderApi(
  data: Partial<CustomOAuthProvider>
): Promise<void> {
  return post('/api/custom-oauth-provider/', data)
}

export async function updateCustomOAuthProviderApi(
  id: number,
  data: Partial<CustomOAuthProvider>
): Promise<void> {
  return put(`/api/custom-oauth-provider/${id}`, data)
}

export async function deleteCustomOAuthProviderApi(id: number): Promise<void> {
  return del(`/api/custom-oauth-provider/${id}`)
}

export async function discoverCustomOAuthProviderApi(payload: {
  well_known?: string
  authorization_endpoint?: string
  token_endpoint?: string
  user_info_endpoint?: string
}): Promise<Record<string, string>> {
  return post<Record<string, string>>('/api/custom-oauth-provider/discovery', payload)
}
